// import { useScreenMessage, useScreenModalV2 } from '@gogame/screens';

import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { approveSpendAdjustment } from 'scenes/SpendAdjustments/sources/spendAdjustment';

import { approve } from '../queryKeyFactory';

export const useApproveSA = () => {
  const confirm = useScreenModalV2(ConfirmDialog);

  const approveMutation = useMutation(approve(), approveSpendAdjustment, {
    successMessage: () => `Spend Adjustment approved`,
  });

  const handleApprove = ({ id }) =>
    confirm({
      title: `Approve Spend Adjustment ${id}?`,
      confirmActionLabel: 'Approve',
    }).then(() => approveMutation.mutateAsync({ id }));

  return [handleApprove, approveMutation];
};
